import StudentsTable from './StudentsTable';

export default StudentsTable;
